<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      scrollable
      width="700px"
      :content-class="isMobileBreakpoint ? 'fixDialogScroll' : ''"
    >
      <v-card style="min-width: 700px !important">
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-3 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px">
              mdi-history
            </v-icon>
            {{
              item.name
                ? $t('message.pages.historyModal.titleFolder')
                : $t('message.pages.historyModal.titleVideo')
            }}
            <b>{{ item.name || item.title }}</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-row
          no-gutters
          class="pl-8 pr-5 py-0"
          :class="itemLogs.length > 4 ? 'pr-9' : ''"
        >
          <v-col cols="2">
            <span>{{ $t('message.pages.historyModal.column1') }}</span>
          </v-col>
          <v-col cols="2">
            <span>{{ $t('message.pages.historyModal.column2') }}</span>
          </v-col>
          <v-col cols="3">
            <span>IP</span>
          </v-col>
          <v-col cols="5">
            <span>{{ $t('message.pages.historyModal.column4') }}</span>
          </v-col>
        </v-row>
        <v-card-text
          v-if="!isFetching"
          class="pl-8 pr-5 py-0"
          style="height: 300px"
        >
          <v-col cols="12" class="pa-0 py-2">
            <v-divider />
          </v-col>
          <v-row
            v-if="errors.fetch"
            class="d-flex flex-column mt-4"
            no-gutters
            justify="center"
            align="center"
          >
            <v-card width="76%" flat>
              <span class="text-subheading text-center">
                {{ $t('message.videoApiErrMsg') }}
                <button
                  type="button"
                  class="primary--text"
                  @click="handleStatusPage"
                >
                  <span class="primary--text">
                    {{ $t('message.checkStatusPageLink') }}
                  </span>
                </button>
              </span>
            </v-card>
            <v-btn
              color="primary"
              class="mt-4 white--text"
              rounded
              @click="fetchData"
            >
              <span class="mx-2">{{ $t('message.tryAgain') }}</span>
              <v-icon right dark> mdi-cached </v-icon>
            </v-btn>
          </v-row>
          <template v-else>
            <v-row
              v-if="!itemLogs.length"
              class="d-flex flex-column mt-4"
              no-gutters
              justify="center"
              align="center"
            >
              <span>
                {{
                  item.name
                    ? $t('message.pages.historyModal.theFolder')
                    : $t('message.pages.historyModal.theVideo')
                }}: <b>{{ item.name || item.title }}</b>
                {{ $t('message.pages.historyModal.noHistoryText') }}</span
              >
            </v-row>
            <v-row v-else no-gutters v-for="(log, i) in itemLogs" :key="i">
              <v-col cols="2">
                <span>{{ log.type }}</span>
              </v-col>
              <v-col cols="2">
                <span>
                  {{ log.fixedDate }} <br />
                  ás {{ log.fixedTime }}</span
                >
              </v-col>
              <v-col cols="3">
                <span>{{ log.ip }}</span>
              </v-col>
              <v-col cols="5">
                <span
                  v-if="
                    log.userAgent.browser.name === 'Chrome' ||
                    log.userAgent.browser.name === 'Chrome WebView' ||
                    log.userAgent.browser.name === 'Chromium'
                  "
                >
                  <v-icon small>mdi-google-chrome</v-icon>
                  {{ log.userAgent.browser.name }}
                  {{ $t('message.pages.historyModal.version') }}:
                  {{ log.userAgent.browser.version }}
                </span>
                <span
                  v-else-if="
                    log.userAgent.browser.name === 'Safari' ||
                    log.userAgent.browser.name === 'Mobile Safari'
                  "
                >
                  <v-icon small>mdi-apple-safari</v-icon>
                  {{ log.userAgent.browser.name }}
                  {{ $t('message.pages.historyModal.version') }}:
                  {{ log.userAgent.browser.version }}
                </span>
                <span v-else-if="log.userAgent.browser.name === 'Edge'">
                  <v-icon small>mdi-microsoft-edge</v-icon>
                  {{ log.userAgent.browser.name }}
                  {{ $t('message.pages.historyModal.version') }}:
                  {{ log.userAgent.browser.version }}
                </span>
                <span v-else-if="log.userAgent.browser.name === 'Mozilla'">
                  <v-icon small>mdi-firefox</v-icon>
                  {{ log.userAgent.browser.name }}
                  {{ $t('message.pages.historyModal.version') }}:
                  {{ log.userAgent.browser.version }}
                </span>
                <span v-else> Browser: {{ log.userAgent.browser.name }} </span>
                <br />
                <span v-if="log.userAgent.os.name === 'Windows'">
                  <v-icon small>mdi-microsoft-windows</v-icon>
                  {{ log.userAgent.os.name }} {{ log.userAgent.os.version }}
                </span>
                <span
                  v-else-if="
                    log.userAgent.os.name === 'Mac OS' ||
                    log.userAgent.os.name === 'iOS'
                  "
                >
                  <v-icon small>mdi-apple</v-icon> {{ log.userAgent.os.name }}
                  {{ log.userAgent.os.version }}
                </span>
                <span v-else
                  >Sistema operacional: {{ log.userAgent.os.name }}</span
                >
              </v-col>

              <v-col cols="12" class="pa-0 py-2">
                <v-divider />
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card
          v-else
          class="d-flex flex-row align-center justify-center"
          flat
          height="300px"
          :width="isMobileBreakpoint ? '50%' : '100%'"
        >
          <loading-logo :value="200" />
        </v-card>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn text class="px-4" min-width="185px" @click="handleClose">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import foldersApi from '../services/foldersApi'
import videosApi from '../services/videosApi'
import LoadingLogo from './LoadingLogo.vue'
import parseUserAgent from 'ua-parser-js'
import { PANDA_STATUS_PAGE_BR, PANDA_STATUS_PAGE } from '@/config/envs'
import i18n from '@/translations/lang'
import { mapState } from 'vuex'

export default {
  name: 'ModalItemLogs',
  components: { LoadingLogo },
  data: () => ({
    open: false,
    isFetching: false,
    item: {},
    itemLogs: [],
    errors: {
      fetch: false,
    },
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
  },
  watch: {
    open() {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
  },
  mounted() {
    this.$root.$on('openModalItemLogs', async (item) => {
      Object.assign(this.$data, this.initialState())
      if (item) {
        this.open = true
        this.item = item
        this.fetchData()
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('openModalItemLogs')
  },
  methods: {
    async fetchData() {
      this.isFetching = true
      this.errors.fetch = false
      if (this.item.name) {
        await this.getFolderLogs()
      } else {
        await this.getVideoLogs()
      }
    },
    parseUA(ua) {
      let result = parseUserAgent(ua)
      return result
    },
    parseType(type) {
      if (type === 'recover')
        return i18n.t('message.pages.historyModal.recover')
      if (type === 'delete') return i18n.t('message.pages.historyModal.delete')
      return type
    },
    parseDate(timestamp) {
      let date = new Date(timestamp)
      return (
        date.toLocaleString('pt-BR').slice(0, 3) +
        date.toLocaleString('pt-BR', { month: 'long' }).slice(0, 3) +
        '/' +
        date.toLocaleString('pt-BR').slice(6, 10)
      )
    },
    parseHours(timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    async getFolderLogs() {
      try {
        let ret = await foldersApi.getFolderVideos(this.item.id, true)
        if (ret.data.logs) this.setFixedLogs(ret.data.logs)
        this.isFetching = false
      } catch (e) {
        this.isFetching = false
        this.errors.fetch = true
        console.error(e)
      }
    },
    async getVideoLogs() {
      try {
        let ret = await videosApi.getAVideo(this.item.id, true)
        if (ret.data.logs) this.setFixedLogs(ret.data.logs)
        this.isFetching = false
      } catch (e) {
        this.isFetching = false
        this.errors.fetch = true
        console.error(e)
      }
    },
    setFixedLogs(rawLogs) {
      let logs = rawLogs.sort((a, b) => a.date - b.date)
      let fixedLogs = logs.map((log) => {
        return {
          ip: log.json.ip,
          type: this.parseType(log.json.type),
          userAgent: this.parseUA(log.json.user_agent),
          fixedTime: this.parseHours(log.date),
          fixedDate: this.parseDate(log.date),
        }
      })
      this.itemLogs = fixedLogs
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    handleStatusPage() {
      let loc = this.getLocale()
      if (loc === 'pt-BR') return window.open(PANDA_STATUS_PAGE_BR, '_blank')
      return window.open(PANDA_STATUS_PAGE, '_blank')
    },
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        open: false,
        isFetching: false,
        item: {},
        itemLogs: [],
      }
    },
  },
}
</script>

<style lang="scss">
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.fixDialogScroll {
  overflow-x: scroll !important;
}
</style>
